import { Component } from '@grafikr/components';

import Cart from 'utils/cart';

const GENDERS = new Set(['male', 'female']);

export default Component((node, { onMounted }) => {
  onMounted(() => {
    const resourceGender = node.dataset.resourceGender ?? '';
    const cartGender = node.dataset.cartGender ?? '';

    if (!GENDERS.has(resourceGender) || resourceGender === cartGender) {
      return;
    }

    const formData = new FormData();
    formData.set('attributes[gender]', resourceGender);

    void Cart.update(formData);
  });
});
